<template>
  <div>
    <b-row>
      <b-col cols="2">
        {{$t('menu.store_group')}}
      </b-col>
      <b-col cols="10">
        <multi-select v-model="store_group_value" label="name_tmp" track-by="name_tmp" :placeholder="$t('menu.select_one')" :reset-after="true"
                     :options="storeGroups"  :show-labels="false" @input="chooseStoreGroup">
          <template slot="singleLabel" slot-scope="props"><i class="fa fa-search"></i><span class="option__desc">
                      <span class="option__title" style="opacity: 0.4;color: #2A2C36;font-family: Roboto;font-size: 16px;line-height: 24px;"> {{$t('menu.select_store_group')}} ...</span></span></template>
        </multi-select>
        <div class="storeGroupLabel">
             <span class="storeTab" v-for="(group, index) in storeGroupsTemp">
              <span>{{group.name_tmp}}</span>
              <span class="close-btn" @click="removeStoreGroup(index, group)">
                <i class="fa fa-angle-right"></i>
                <i class="fa fa-angle-left"></i>
              </span>
            </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        {{$t('menu.store')}}
      </b-col>

      <b-col cols="10">
        <multi-select v-model="store_value" label="name_tmp" track-by="name_tmp" :placeholder="$t('menu.select_one')" :reset-after="true"
                     :options="stores"  :show-labels="false" @input="chooseStore">
          <template slot="singleLabel" slot-scope="props"><i class="fa fa-search"></i><span class="option__desc">
                      <span class="option__title" style="opacity: 0.4;color: #2A2C36;font-family: Roboto;font-size: 16px;line-height: 24px;"> {{$t('menu.select_store')}} ...</span></span></template>
        </multi-select>
        <div class="storeGroupLabel">
             <span class="storeTab" v-for="(store, index) in storesTemp">
              <span>{{store.name_tmp}}</span>
              <span class="close-btn" @click="removeStore(index, store)">
                <i class="fa fa-angle-right"></i>
                <i class="fa fa-angle-left"></i>
              </span>
            </span>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        {{$t('menu.store_exclude')}}
      </b-col>

      <b-col cols="10">
        <multi-select v-model="store_exclude_value" label="name_tmp" track-by="name_tmp" :placeholder="$t('menu.select_one')" :reset-after="true"
                      :options="storesExclude"  :show-labels="false" @input="chooseStoreExclude">
          <template slot="singleLabel" slot-scope="props"><i class="fa fa-search"></i><span class="option__desc">
                      <span class="option__title" style="opacity: 0.4;color: #2A2C36;font-family: Roboto;font-size: 16px;line-height: 24px;"> {{$t('menu.select_store')}} ...</span></span></template>
        </multi-select>
        <div class="storeGroupLabel">
             <span class="storeTab" v-for="(store, index) in storesExcludeTemp">
              <span>{{store.name_tmp}}</span>
              <span class="close-btn" @click="removeStoreExclude(index, store)">
                <i class="fa fa-angle-right"></i>
                <i class="fa fa-angle-left"></i>
              </span>
            </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'

export default {
  name: 'ModalStoreForm',
  props: {
    storeListOrigin: {
      type: Array,
      required: false,
      default: []
    },
    stores: {
      type: Array,
      required: false,
      default: []
    },
    storesTemp: {
      type: Array,
      required: false,
      default: []
    },
    storesExclude: {
      type: Array,
      required: false,
      default: []
    },
    storesExcludeTemp: {
      type: Array,
      required: false,
      default: []
    },
    storeGroups: {
      type: Array,
      required: false,
      default: []
    },
    storeGroupsTemp: {
      type: Array,
      required: false,
      default: []
    }
  },
  components: {
    MultiSelect
  },
  data: function () {
    return {
      store_group_value: {},
      store_value: {},
      store_exclude_value: {}
    }
  },
  methods: {
    _handleExclude(group) {
      console.log(group)
      let data = group.outlet_ids
      let uuids = []
      for (let i in this.storesExclude) {
        uuids.push(this.storesExclude[i])
      }
      for (let i in this.storesExcludeTemp) {
        uuids.push(this.storesExcludeTemp[i])
      }
      for (let i in this.storeListOrigin) {
        if (data.indexOf(this.storeListOrigin[i].uuid) >= 0 && uuids.indexOf(this.storeListOrigin[i].uuid) < 0) {
          this.storesExclude.push(this.storeListOrigin[i])
        }
      }
      this.sortStoreExclude()
    },
    removeStore (index, value) {
      this.storesTemp.splice(index, 1)
      this.stores.push(value)
      this.sortS()
    },
    removeStoreExclude (index, value) {
      this.storesExcludeTemp.splice(index, 1)
      this.storesExclude.push(value)
      this.sortStoreExclude()
    },
    removeStoreGroup (index, value) {
      this.storeGroupsTemp.splice(index, 1)
      this.storeGroups.push(value)
      this.sortG()
    },
    chooseStore (value) {
      if (value == null) {
        return false
      }
      let index = this.stores.indexOf(value)
      this.stores.splice(index, 1)
      this.storesTemp.push(value)
      this.sortS()
    },
    chooseStoreExclude (value) {
      if (value == null) {
        return false
      }
      let index = this.storesExclude.indexOf(value)
      this.storesExclude.splice(index, 1)
      this.storesExcludeTemp.push(value)
      this.sortStoreExclude()
    },
    chooseStoreGroup (value) {
      if (value == null) {
        return false
      }
      let index = this.storeGroups.indexOf(value)
      this.storeGroups.splice(index, 1)
      this.storeGroupsTemp.push(value)
      this.sortG()
      this._handleExclude(value)
    },
    sortG () {
      let data = this._.cloneDeep(this.storeGroups)
      data = this._.sortBy(data, ['name_tmp'])
      if (this.storeGroups.length > 0) {
        this.storeGroups.splice(0, this.storeGroups.length)
      }
      for (let i in data) {
        this.storeGroups.push(data[i])
      }

      let dataT = this._.cloneDeep(this.storeGroupsTemp)
      dataT = this._.sortBy(dataT, ['name_tmp'])
      if (this.storeGroupsTemp.length > 0) {
        this.storeGroupsTemp.splice(0, this.storeGroupsTemp.length)
      }
      for (let i in dataT) {
        this.storeGroupsTemp.push(dataT[i])
      }
    },
    sortS () {
      let data = this._.cloneDeep(this.stores)
      data = this._.sortBy(data, ['name_tmp'])
      if (this.stores.length > 0) {
        this.stores.splice(0, this.stores.length)
      }
      for (let i in data) {
        this.stores.push(data[i])
      }

      let dataT = this._.cloneDeep(this.storesTemp)
      dataT = this._.sortBy(dataT, ['name_tmp'])
      if (this.storesTemp.length > 0) {
        this.storesTemp.splice(0, this.storesTemp.length)
      }
      for (let i in dataT) {
        this.storesTemp.push(dataT[i])
      }
    },
    sortStoreExclude () {
      let data = this._.cloneDeep(this.storesExclude)
      data = this._.sortBy(data, ['name_tmp'])
      if (this.storesExclude.length > 0) {
        this.storesExclude.splice(0, this.storesExclude.length)
      }
      for (let i in data) {
        this.storesExclude.push(data[i])
      }

      let dataT = this._.cloneDeep(this.storesExcludeTemp)
      dataT = this._.sortBy(dataT, ['name_tmp'])
      if (this.storesExcludeTemp.length > 0) {
        this.storesExcludeTemp.splice(0, this.storesExcludeTemp.length)
      }
      for (let i in dataT) {
        this.storesExcludeTemp.push(dataT[i])
      }
    }
  },
  watch: {
  }
}
</script>
<style>
  .menu-form .modal-lg{
    max-width: 95%;
  }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/menu/ModalStore.vue